
/* injects from baggage-loader */

export const balloons = [
    'Bem-vindo(a) à <b>Região Norte</b>!<br> O Norte é a maior região<br> brasileira, conhecida por seus rios e sua rica culinária.',
    'O cardápio a seguir está<br> repleto de comidas dessa região! <br>Você deve escutar o pedido do cliente e registrá-lo no tablet! ']




// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.const.js